<template>
  <div class="h-100 my-5">
    <b-button
      type="submit"
      class="myButton"
      @click="$router.go(-1)">
      {{ $t('common.Cancel') }}
    </b-button>
    <div class="dp02 p-3 mt-3 row">
      <div class="text-center col-lg-12">
        <h2>{{ $t('CreateMoneyVoucher.Header') }}</h2>
      </div>
      <ValidationObserver
        ref="observer"
        v-slot="{invalid}"
        tag="form"
        class="col-lg-12 mt-5"
        @submit.prevent="submit()">
        <div class="col-lg-12 row">
          <div class="col-lg-1 offset-lg-4">
            <label for="code">{{ $t('fields.code') }}</label>
          </div>
          <div class="col-lg-3">
            <ValidationProvider
              name="code"
              v-slot="{errors, classes}">
              <b-form-input
                id="code"
                v-model="code"
                :class="{...classes, myInput: true}" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-lg-12 row">
          <div class="col-lg-1 offset-lg-4">
            <label for="amount">{{ $t('fields.amount') }}</label>
          </div>
          <div class="col-lg-3">
            <ValidationProvider
              name="amount"
              rules="required|greaterThanZero"
              v-slot="{errors, classes}">
              <b-form-input
                id="amount"
                type="number"
                v-model="amount"
                :class="{...classes, myInput: true}" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-lg-12 row">
          <div class="col-lg-1 offset-lg-4">
            <label for="voucherType">{{ $t('fields.voucherType') }}</label>
          </div>
          <div class="col-lg-3">
            <VoucherTypeInput v-model="voucherType"
                              :editable="!isCodeFilled" />
          </div>
        </div>
        <div class="col-lg-12 row mt-3"
             v-show="voucherType === 2">
          <div class="col-lg-1 offset-lg-4">
            <label for="forWho">{{ $t('fields.forWho') }}</label>
          </div>
          <div class="col-lg-3">
            <ValidationProvider
              name="forWho"
              :rules="voucherType === 2 ? 'required' : ''"
              v-slot="{errors, classes}">
              <b-form-input
                id="forWho"
                v-model="forWho"
                :class="{...classes, myInput: true}" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-lg-12 row mt-3"
             v-show="voucherType === 2">
          <div class="col-lg-1 offset-lg-4">
            <label for="fromWho">{{ $t('fields.fromWho') }}</label>
          </div>
          <div class="col-lg-3">
            <b-form-input
              id="fromWho"
              v-model="fromWho"
              :class="{...classes, myInput: true}" />
          </div>
        </div>
        <div class="col-lg-12 row mt-3">
          <div class="col-lg-1 offset-lg-4">
            <label for="validTo">{{ $t('fields.validTo') }}</label>
          </div>
          <div class="col-lg-3">
            <ValidationProvider
              name="validTo"
              rules="required"
              v-slot="{errors}">
              <el-date-picker
                :picker-options="{
                  firstDayOfWeek: 1
                }"
                id="validTo"
                :class="{
                  datepicker: true
                }"
                name="validTo"
                v-model="validTo"
                :disabled="false"
                format="dd.MM.yyyy"
                value-format="yyyy-MM-dd" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-lg-12 row mt-3"
             v-show="!isCodeFilled">
          <div class="col-lg-1 offset-lg-4">
            <label for="howMany">{{ $t('CreateMoneyVoucher.Amount') }}</label>
          </div>
          <div class="col-lg-3">
            <ValidationProvider
              name="howMany"
              rules="required|greaterThanZero"
              v-slot="{errors, classes}">
              <b-form-input
                id="howMany"
                type="number"
                v-model="howMany"
                :class="{...classes, myInput: true}" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-lg-12 row"
             v-show="isCodeFilled">
          <div class="col-lg-1 offset-lg-4">
            <label for="usageCount">{{ $t('fields.maxUsageCount') }}</label>
          </div>
          <div class="col-lg-3">
            <ValidationProvider
              name="usageCount"
              rules="required|greaterThanOrEqualZero"
              v-slot="{errors, classes}">
              <b-form-input
                id="usageCount"
                type="number"
                v-model="usageCount"
                :class="{...classes, myInput: true}" />
              <p class="myInputError mt-2">
                {{ errors[0] }}
              </p>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-lg-12 text-center">
          <b-button
            class="mt-3 myButton align-middle"
            type="submit">
            {{ $t('CreateMoneyVoucher.CreateVouchers') }}
          </b-button>
          <b-spinner
            v-show="creating"
            variant="primary"
            class="align-middle ml-3"
            label="Spinning" />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import VoucherTypeInput from '@components/input/VoucherTypeInput';

export default {
  name: 'CreateMoneyVoucher',
  components: {
    VoucherTypeInput
  },
  data() {
    return {
      creating: false
    };
  },
  computed: {
    isCodeFilled: {
      get() {
        return this.code && this.code !== '';
      }
    },
    code: {
      get() {
        return this.$store.state.createMoneyVoucher.code;
      },
      set(val) {
        if (val !== '') {
          this.setVoucherType(1);
        }
        this.setCode(val);
      }
    },
    howMany: {
      get() {
        return this.$store.state.createMoneyVoucher.howMany;
      },
      set(val) {
        this.setHowMany(val);
      }
    },
    amount: {
      get() {
        return this.$store.state.createMoneyVoucher.amount;
      },
      set(val) {
        this.setAmount(val);
      }
    },
    voucherType: {
      get() {
        return this.$store.state.createMoneyVoucher.voucherType;
      },
      set(val) {
        this.setVoucherType(val);
      }
    },
    validTo: {
      get() {
        return this.$store.state.createMoneyVoucher.validTo;
      },
      set(val) {
        this.setValidTo(val);
      }
    },
    forWho: {
      get() {
        return this.$store.state.createMoneyVoucher.forWho;
      },
      set(val) {
        this.setForWho(val);
      }
    },
    fromWho: {
      get() {
        return this.$store.state.createMoneyVoucher.fromWho;
      },
      set(val) {
        this.setFromWho(val);
      }
    },
    usageCount: {
      get() {
        return this.$store.state.createMoneyVoucher.usageCount;
      },
      set(val) {
        this.setUsageCount(val);
      }
    },
  },
  created() {
    this.resetContext();
  },
  methods: {
    ...mapMutations({
      setCode: 'createMoneyVoucher/setCode',
      setHowMany: 'createMoneyVoucher/setHowMany',
      setAmount: 'createMoneyVoucher/setAmount',
      setVoucherType: 'createMoneyVoucher/setVoucherType',
      setValidTo: 'createMoneyVoucher/setValidTo',
      setForWho: 'createMoneyVoucher/setForWho',
      setFromWho: 'createMoneyVoucher/setFromWho',
      setUsageCount: 'createMoneyVoucher/setUsageCount'
    }),
    ...mapActions({ resetContext: 'createMoneyVoucher/resetContext',
      createVoucher: 'createMoneyVoucher/createVoucher' }),
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.creating = true;
        this.createVoucher()
          .then(() => {
            this.creating = false;
            this.resetContext();
            this.$root.$bvToast.toast(this.$t('CreateMoneyVoucher.SuccessToast.Body'), {
              title: this.$t('CreateMoneyVoucher.SuccessToast.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
            this.$router.replace({ name: 'admin.vouchers.view' });
          })
          .catch(() => {
            this.$root.$bvToast.toast(this.$t('CreateMoneyVoucher.FailToast.Body'), {
              title: this.$t('CreateMoneyVoucher.FailToast.Title'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
